import React, { useContext, useEffect, useState } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import Main from "./Main";
import routes from "../routes";
import Header from "components/header/Header";
import Sidebar from "components/sidebar/Sidebar";
import { SidebarContext } from "context/SidebarContext";
import RouteErrorBoundary from "components/common/RouteErrorBoundary";
import Page404 from "../pages/404";
import AdminServices from "services/AdminServices";
import { canAccessRoute } from "utils/routePrivileges";

const Layout = () => {
  const { isSidebarOpen, closeSidebar, navBar } = useContext(SidebarContext);
  const location = useLocation();
  const [userSlugs, setUserSlugs] = useState(null);

  useEffect(() => {
    closeSidebar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    let cancelled = false;
    async function loadPrivileges() {
      try {
        const adminInfoString = Cookies.get("adminInfo");
        if (!adminInfoString) {
          if (!cancelled) setUserSlugs([]);
          return;
        }
        const adminInfo = JSON.parse(adminInfoString);
        if (!adminInfo?.id) {
          if (!cancelled) setUserSlugs([]);
          return;
        }
        const response = await AdminServices.getStaffById(adminInfo.id);
        const slugs = (response.data?.previleges || []).map((p) => p.slug);
        if (!cancelled) setUserSlugs(slugs);
      } catch (e) {
        if (!cancelled) setUserSlugs([]);
      }
    }
    loadPrivileges();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className={`flex h-screen bg-gray-50 dark:bg-gray-900 ${
        isSidebarOpen && "overflow-hidden"
      }`}
    >
      {navBar && <Sidebar />}

      <div className="flex flex-col flex-1 w-full min-w-0">
        <Header />
        <Main>
          <RouteErrorBoundary locationKey={location.pathname}>
            <Switch location={location}>
              {routes.map((route, i) => {
                if (!route.component) return null;
                return (
                  <Route
                    key={route.path || i}
                    exact={true}
                    path={`${route.path}`}
                    render={(props) => {
                      // Wait until privileges are loaded before blocking
                      if (userSlugs === null) {
                        return null;
                      }
                      if (!canAccessRoute(route.path, userSlugs)) {
                        return <Redirect to="/dashboard" />;
                      }
                      return <route.component {...props} />;
                    }}
                  />
                );
              })}
              <Redirect exact from="/" to="/dashboard" />
              <Route component={Page404} />
            </Switch>
          </RouteErrorBoundary>
        </Main>
      </div>
    </div>
  );
};

export default Layout;
